import { connect } from 'react-redux';

import HeaderBackground from '../components/HeaderBackground';

const _mapStateToProps = ({ header = {} }) => ({
    headerImages: header.images,
});

export default connect(_mapStateToProps)(HeaderBackground);
